/** Access changes are principal-wide. Conservatively invalidate every open
 * review: a hidden external target cannot safely be matched by a disclosed id.
 * No reviewed content or identifiers are retained in this signal. */
import { useSyncExternalStore } from 'react';

let epoch = 0;
const listeners = new Set<() => void>();
export function invalidateReviewAccess(): void {
  epoch += 1;
  for (const listener of listeners) listener();
}
const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
};
/** The current access epoch, outside React (a data-layer cache's key). */
export function reviewAccessEpoch(): number {
  return epoch;
}
export function useReviewAccessEpoch(): number {
  return useSyncExternalStore(subscribe, () => epoch, () => 0);
}
